import { all, fork } from 'redux-saga/effects';
import { watchFetchActions } from './actions';
import { watchFetchArticleOG } from './articles';
import { watchFetchTrumpisms, watchGetTrumpism } from './trumpisms';

export default function* rootSaga() {
  yield all([
    fork(watchFetchActions),
    fork(watchFetchArticleOG),
    fork(watchFetchTrumpisms),
    fork(watchGetTrumpism)
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas/index.js